import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=d6a2b95e&"
import script from "./ClockIcon.vue?vue&type=script&lang=ts&"
export * from "./ClockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports